module.exports = __webpack_public_path__ + "img/64.150f033a.png";